import 'whatwg-fetch';

export async function createMembers(body: object, callback: (res: object) => void) {
  const result = await window.fetch('/api/_private/memberships/batch', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
    .then(handleErrors)
    .then((res) => callback(res))
    .catch((err) => {
      console.error(err.responseText);
    });

  return result;
}

const handleErrors = (res) => {
  if (!res.ok) {
    res.json().then((error) => {
      alert(error.message || 'Something went wrong with your request. Please refresh the page');
      throw Error(error.message);
    });
  }
  return res;
};
